<template lang="html">
    <section class="banner-fp">
        <div class="box container">
            <div class="producto-desc row-between container">
                <div class="texto waypoints" data="fadeInUp">
                    <h2 class="title" v-html="$t('banner_fp.title')
                        "></h2>
                    <p v-html="$t('banner_fp.text')
                        "></p>

                    <a class="btn-rounded-blue" :href="$t('enlaces.iformalia_fp')" target="_blank">
                        {{ $t("banner_fp.btn") }}
                    </a>
                </div>
                <img class="waypoints" data="fadeInUp" src="/static/img/fp/fp.png" alt="iformalia fp" />
            </div>
        </div>
    </section>
</template>

<script lang="js">
export default {
    name: 'banner-fp',
    props: [],
    mounted() { },
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
.banner-fp {
    margin: 60px 0;
}

.banner-fp .producto-desc {
    display: flex;
}

.banner-fp .texto {
    width: 50%;
    max-width: 530px;
    text-align: left;
}

.banner-fp img {
    width: 50%;
    max-width: 530px;
}

.banner-fp .title {
    color: #3374b0;
    margin-bottom: 20px;
    line-height: 1.2em;
}

.banner-fp p {
    line-height: 28px;
    font-size: 16px;
    color: #41566d;
    margin-bottom: 30px;
    text-align: left;
}

.banner-fp strong {
    font-weight: 600;
}

@media screen and (max-width: 1145px) {
    .banner-fp .texto {
        width: 100%;
        max-width: 100%;
        text-align: left;
        padding: 0 20px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .banner-fp p {
        max-width: 100%;
    }
    .box.container img {
        margin: 0 auto;
    }
}

@media screen and (max-width: 600px) {

    .box.container img {
        width: 100%;
    }

    h3 {
        line-height: 24px;
        padding: 0 20px;
    }

    .banner-fp .texto {
        padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer/banner-fp.vue